import { useEffect, useRef, useState } from 'react';
import { EventObject, interpret, StateMachine, Typestate } from 'xstate';

export const useMachine = <TContext, TEvent extends EventObject, TTypestate extends Typestate<TContext> = any>(
  machine: StateMachine<TContext, any, TEvent, TTypestate>,
): [
  any, // State<TContext, TEvent, any, TTypestate>,
  any, //Interpreter<TContext, any, TEvent, TTypestate>['send'],
] => {
  const [current, setCurrent] = useState(machine.initialState);
  const serviceRef = useRef<any>(null);

  useEffect(() => {
    const service = interpret(machine)
      .onTransition((state) => {
        if (state.changed) {
          setCurrent(state);
        }
      })
      .start();

    serviceRef.current = service;

    // Set initial state in case machine doesn't emit a transition on start
    setCurrent(service.state);

    return () => {
      service.stop();
      serviceRef.current = null;
    };
  }, [machine]);

  return [current, (event: TEvent) => serviceRef.current?.send(event)];
};
